<template>
  <div class="app-navbar"
       v-loading.fullscreen.lock="loading"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-menu :default-active="curMenuIdx"
             mode="horizontal"
             class=""
             @select="selMenu">
      <el-submenu index="10" class="submenu" v-if="userLevelId == 1">
        <template slot="title">
          <i class="iconfont" :class="reportIcon"></i>
          {{ reportTitle }}
        </template>
        <div class="menu-item">
          <el-menu-item index="11" v-if="userLevelId == 1">
            <i class="iconfont icon-font-menu-report"></i>报告查询
          </el-menu-item>
          <el-menu-item index="12" v-if="userLevelId == 1">
            <i class="iconfont icon-font-info-interfince"></i>登录次数查询
          </el-menu-item>
          <el-menu-item index="13" v-if="userLevelId == 1">
            <i class="iconfont icon-font-order-count"></i>医嘱统计
          </el-menu-item>
          <el-menu-item index="14" v-if="userLevelId == 1">
            <i class="iconfont icon-font-report-count"></i>报告数量统计
          </el-menu-item>
        </div>
      </el-submenu>

      <el-menu-item index="11" v-if="userLevelId != 1"><i class="iconfont icon-font-menu-report"></i>报告查询</el-menu-item>
      <el-menu-item index="51" v-if="userLevelId != 1 && userLevelId != 2"><i class="iconfont icon-font-menu-report"></i>标本流转</el-menu-item>
      <el-submenu index="20" class="submenu" v-if="userLevelId<4">
        <template slot="title">
          <i class="iconfont" :class="settingIcon"></i>
          {{ settingTitle }}
        </template>
        <div class="menu-item">
          <el-menu-item index="21" v-if="userLevelId == 1">
            <i class="iconfont icon-font-menu-setup-range"></i>地域设置
          </el-menu-item>
          <el-menu-item index="22" v-if="userLevelId == 1 || userLevelId == 2">
            <i class="iconfont icon-font-menu-setup-emp"></i>人员设置
          </el-menu-item>
          <el-menu-item index="23" v-if="userLevelId == 1 || userLevelId == 2 || userLevelId == 3 ">
            <i class="iconfont icon-font-menu-setup-branch"></i>医院设置
          </el-menu-item>
          <el-menu-item index="24" v-if="userLevelId == 1 || userLevelId == 2">
            <i class="iconfont icon-font-menu-setup-report"></i>报表文件管理
          </el-menu-item>
          <el-menu-item index="25" v-if="userLevelId == 1 || userLevelId == 2">
            <i class="iconfont icon-font-menu-setup-branch"></i>医嘱设置
          </el-menu-item>
        </div>

      </el-submenu>
      <el-submenu index="30" class="submenu" v-if="userLevelId == 1">
        <template slot="title">
          <i class="iconfont" :class="interfinceIcon"></i>
          {{ interfinceTitle }}
        </template>
        <div class="menu-item">
          <el-menu-item index="31" v-if="userLevelId == 1">
            <i class="iconfont icon-font-setup-interfince"></i>接口设置
          </el-menu-item>
          <el-menu-item index="32" v-if="userLevelId == 1 || userLevelId == 2">
            <i class="iconfont icon-font-info-interfince"></i>样本查询
          </el-menu-item>
        </div>
      </el-submenu>
      <el-menu-item index="41" v-if="userLevelId == 1"> <i class="iconfont icon-font-menu-report"></i>消息发布</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
  export default {
    name: "Navbar",
    data() {
      return {
        loading: false,
        userLevelId: null,

        settingTitle: '基础管理',
        settingIcon: 'icon-font-menu-setting',

        interfinceTitle: '接口管理',
        interfinceIcon: 'icon-font-menu-interfince',

        reportTitle: '报告管理',
        reportIcon: 'icon-font-menu-report',

        curMenuIdx: '11',
        dlgBatchCreateBarcodeVisibleSync: false,
      };
    },
    mounted() {
      //userLevelId  1=超级管理员 2=管理员 3=组长 5=高级操作员  4=操作员 6=调阅员
      let userInfo = this.common.getCookie("userInfo");
      if (userInfo) {
        this.userLevelId = userInfo.UserLevelId;
      }
      if (this.common.IsNull(this.userLevelId)) {
        this.$router.push({ path: "/" });
        return;
      }

      this.menuStyle();
    },
    methods: {
      selMenu(key, keyPath) {
        if (key != 21 && key != 22 && key != 23 && key != 24 && key != 25) {
          this.settingTitle = '基础管理';
          this.settingIcon = 'icon-font-menu-setting';
        }
        if (key != 31 && key != 32) {
          this.interfinceTitle = '接口管理';
          this.interfinceIcon = 'icon-font-menu-interfince';
        }
        if (key != 11 && key != 12 && key != 13 && key != 14) {
          this.reportTitle = '报告管理';
          this.reportIcon = 'icon-font-menu-report';
        }
        if (key == 11 && this.$route.name != 'FrmReport') {
          this.reportTitle = '报告查询';
          this.reportIcon = 'icon-font-menu-report';
          this.$router.push({ path: '/biz/FrmReport' });
        } else if (key == 12 && this.$route.name != 'FrmLoginCount') {
          this.reportTitle = '登录次数查询';
          this.reportIcon = 'icon-font-info-interfince';
          this.$router.push({ path: '/biz/FrmLoginCount' });
        } else if (key == 13 && this.$route.name != 'FrmOrderCount') {
          this.reportTitle = '医嘱统计';
          this.reportIcon = 'icon-font-order-count';
          this.$router.push({ path: '/biz/FrmOrderCount' });
        } else if (key == 14 && this.$route.name != 'FrmReportCount') {
          this.reportTitle = '报告数量统计';
          this.reportIcon = 'icon-font-report-count';
          this.$router.push({ path: '/biz/FrmReportCount' });
        } else if (key == 51 && this.$route.name != 'FrmSpecTrans') {
          this.$router.push({ path: '/biz/FrmSpecTrans' });
        } else if (key == 21 && this.$route.name != 'FrmRegionSetup') {
          this.settingTitle = '地域设置';
          this.settingIcon = 'icon-font-menu-setup-range';
          this.$router.push({ path: '/baseData/FrmRegionSetup' });
        } else if (key == 22 && this.$route.name != 'FrmUserSetup') {
          this.settingTitle = '人员设置';
          this.settingIcon = 'icon-font-menu-setup-emp';
          this.$router.push({ path: '/baseData/FrmUserSetup' });
        } else if (key == 23 && this.$route.name != 'FrmHospitalSetup') {
          this.settingTitle = '医院设置';
          this.settingIcon = 'icon-font-menu-setup-branch';
          this.$router.push({ path: '/baseData/FrmHospitalSetup' });
        } else if (key == 24 && this.$route.name != 'FrmReportFileManage') {
          this.settingTitle = '报表文件设置';
          this.settingIcon = 'icon-font-menu-setup-report';
          this.$router.push({ path: '/baseData/FrmReportFileManage' });
        } else if (key == 25 && this.$route.name != 'FrmOrderSetup') {
          this.settingTitle = '医嘱设置';
          this.settingIcon = 'icon-font-menu-setup-branch';
          this.$router.push({ path: '/baseData/FrmOrderSetup' });
        } else if (key == 31 && this.$route.name != 'FrmInterfinceSetup') {
          this.interfinceTitle = '接口设置';
          this.interfinceIcon = 'icon-font-setup-interfince';
          this.$router.push({ path: '/interfince/FrmInterfinceSetup' });
        } else if (key == 32 && this.$route.name != 'FrmInterfinceInfo') {
          this.interfinceTitle = '样本查询';
          this.interfinceIcon = 'icon-font-info-interfince';
          this.$router.push({ path: '/interfince/FrmInterfinceInfo' });
        }else if (key == 41 && this.$route.name != 'FrmSendNotice') {
          this.$router.push({ path: '/FrmSendNotice' });
        }
      },
      menuStyle() {
        if (this.$route.name == 'FrmRegionSetup') {
          this.curMenuIdx = '21';
          this.settingTitle = '地域设置';
          this.settingIcon = 'icon-font-menu-setup-range';
        } else if (this.$route.name == 'FrmUserSetup') {
          this.curMenuIdx = '22';
          this.settingTitle = '人员设置';
          this.settingIcon = 'icon-font-menu-setup-emp';
        } else if (this.$route.name == 'FrmHospitalSetup') {
          this.curMenuIdx = '23';
          this.settingTitle = '医院设置';
          this.settingIcon = 'icon-font-menu-setup-branch';
        } else if (this.$route.name == 'FrmReportFileManage') {
          this.curMenuIdx = '24';
          this.settingTitle = '报表文件设置';
          this.settingIcon = 'icon-font-menu-setup-report';
        } else if (this.$route.name == 'FrmOrderSetup') {
          this.curMenuIdx = '25';
          this.settingTitle = '医嘱设置';
          this.settingIcon = 'icon-font-menu-setup-branch';
        } else if (this.$route.name == 'FrmInterfinceSetup') {
          this.curMenuIdx = '31';
          this.interfinceTitle = '接口设置';
          this.interfinceIcon = 'icon-font-setup-interfince';
        } else if (this.$route.name == 'FrmInterfinceInfo') {
          this.curMenuIdx = '32';
          this.interfinceTitle = '样本查询';
          this.interfinceIcon = 'icon-font-info-interfince';
        } else if (this.$route.name == 'FrmSendNotice') {
          this.curMenuIdx = '41';
          this.settingTitle = '消息发布';
          this.settingIcon = 'iconfont icon-font-menu-report';
        } else if (this.$route.name == 'FrmSpecTrans') {
          this.curMenuIdx = '51';
          this.settingTitle = '标本流转';
          this.settingIcon = 'iconfont icon-font-menu-report';
        } else if (this.$route.name == 'FrmReport') {
          this.curMenuIdx = '11';
          this.reportTitle = '报告查询';
          this.reportIcon = 'icon-font-menu-report';
        } else {
          this.settingTitle = '基础管理';
          this.settingIcon = 'icon-font-menu-setting';
          this.interfinceTitle = '接口管理';
          this.interfinceIcon = 'icon-font-menu-interfince';
        }
      },
    },
  };
</script>

<style lang="scss" scoped="">
  .app-navbar {
    height: 52px;
    background: #fff;
    position: absolute;
    left: 330px;
    top: 0px;
  }

    .app-navbar .el-menu--horizontal {
      border: none;
      background: transparent;
      border-radius: 8px;
    }

      .app-navbar .el-menu--horizontal > .el-menu-item {
        height: 60px;
        line-height: 35px;
        color: #666666;
        font-size: 16px;
        letter-spacing: 2px;
        background: transparent;
        min-width: 160px;
        border: 2px solid transparent;
        text-align: center;
      }

        .app-navbar .el-menu--horizontal > .el-menu-item span {
          vertical-align: initial;
        }

        .app-navbar .el-menu--horizontal > .el-menu-item.is-active {
          color: rgba(36,166,240,1);
          background: rgba(246,247,249,1);
          border-color: rgba(246,247,249,1);
          border-radius: 8px;
        }

        .app-navbar .el-menu--horizontal > .el-menu-item i {
          color: #666666;
          font-weight: normal;
          font-size: 16px;
          vertical-align: initial;
          display: block;
          width: 21px;
          height: 20px;
          text-align: center;
          margin: 0 auto;
        }

        .app-navbar .el-menu--horizontal > .el-menu-item.is-active i {
          color: rgba(36,166,240,1);
        }

  .el-dropdown > > > .el-dropdown-link {
    height: 52px;
    line-height: 48px;
    color: #00589c;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 2px;
    background: transparent;
    min-width: 160px;
    border: 2px solid transparent;
    text-align: center;
    font-family: '\5FAE\8F6F\96C5\9ED1',verdana,helvetica,arial,sans-serif;
  }

  .app-navbar .el-menu--horizontal > > > .el-submenu {
    height: 60px;
    line-height: 35px;
    color: #666666;
    font-size: 16px;
    letter-spacing: 2px;
    background: transparent;
    min-width: 160px;
    /*border: 2px solid transparent;*/
    text-align: center;
  }

    .app-navbar .el-menu--horizontal > > > .el-submenu.is-active {
      color: rgba(36,166,240,1);
      background: rgba(246,247,249,1);
      border-color: rgba(246,247,249,1);
      border-radius: 8px;
    }

      .app-navbar .el-menu--horizontal > > > .el-submenu.is-active > > > .el-submenu__title {
        color: rgba(36,166,240,1) !important;
      }

  .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    color: rgba(36,166,240,1) !important;
  }

  .app-navbar .el-menu--horizontal > > > .el-submenu.is-active > > > .el-submenu__title > i {
    color: rgba(36,166,240,1);
  }

  .app-navbar .el-menu--horizontal .el-submenu > > > .el-submenu__title {
    height: 60px;
    line-height: 35px;
    color: #666666;
    font-size: 16px;
    letter-spacing: 2px;
    /*background: transparent;*/
    min-width: 160px;
    text-align: center;
    border-bottom-color: transparent;
    /*color: rgba(36,166,240,1);*/
  }

    .app-navbar .el-menu--horizontal .el-submenu > > > .el-submenu__title > i:first-child {
      display: block;
      width: 21px;
      height: 21px;
      margin-left: 40px;
    }

    .app-navbar .el-menu--horizontal .el-submenu > > > .el-submenu__title > i {
      color: #666666;
      font-weight: normal;
      font-size: 16px;
      vertical-align: initial;
    }

    .app-navbar .el-menu--horizontal .el-submenu > > > .el-submenu__title > span {
      vertical-align: initial;
    }

  .menu-item {
    width: 173px;
    box-shadow: 0 0 5px 1px rgba(77,147,241,.51);
  }

    .menu-item li:hover {
      background-color: rgba(225,240,254,1);
    }

  .el-menu--horizontal .el-menu .el-menu-item.is-active, .el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
    background-color: rgba(246,247,249,1);
    color: rgba(36,166,240,1);
  }

  .el-menu--horizontal .el-menu--popup-bottom-start .el-menu-item.is-active > i {
    color: rgba(36,166,240,1) !important;
  }
</style>



// WEBPACK FOOTER //
// src/layout/compones/navbar.vue